import React from 'react'
import SearchIcon from '@material-ui/icons/Search'
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket'
import { Link } from 'react-router-dom'

import { useStateValue } from '../HOC/StateProvider'
import { auth } from '../../backend/firebase'

import './Header.scss'

const HeaderOption = ({ line1, line2, onClick }: { line1: string; line2: string; onClick?: any }) => {
  return (
    <div className='header__option' onClick={onClick}>
      <span className='header__optionLineOne'>{line1}</span>
      <span className='header__optionLineTwo'>{line2}</span>
    </div>
  )
}

const Header = () => {
  const { state, dispatch } = useStateValue()
  const { basket, user } = state

  const handleAuthentication = () => {
    if (user) auth.signOut()
  }

  return (
    <div className='header'>
      <Link to='/'>
        <img className='header__logo' src='http://pngimg.com/uploads/amazon/amazon_PNG11.png' />
      </Link>

      <div className='header__search'>
        <input className='header__searchInput' type='text' />
        <SearchIcon className='header__searchIcon' fontSize='large' />
      </div>

      <div className='header__nav'>
        <Link to={!user ? '/login' : '#'} className='link'>
          <HeaderOption
            line1={`Hello ${!user ? 'Guest' : user?.email}`}
            line2={!user ? 'Sign In' : 'Sign Out'}
            onClick={handleAuthentication}
          />
        </Link>

        <Link to='/orders' className='link'>
          <HeaderOption line1='Returns' line2='& Orders' />
        </Link>

        <HeaderOption line1='Your' line2='Prime' />

        <Link to='/checkout' className='link'>
          <div className='header__optionBasket'>
            <ShoppingBasketIcon fontSize='large' />
            <span className='header__optionLineTwo header__basketCount'> {basket?.length}</span>
          </div>
        </Link>
      </div>
    </div>
  )
}

export default Header
